import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Footer from './components/Layout/Footer/Footer';
import HomePage from './pages/homepage/HomePage';
import PostPage from './pages/postpage/PostPage';
import ContactPage from './pages/contactpage/ContactPage';
import DetailsPage from './pages/detailspage/DetailsPage';
import SearchResultsPage from './pages/searchresultpage/SearchResultsPage';
import ScrollToTop from './components/ScrollToTop';
import './index.css';
import './styles/global.css';

// ✅ Small wrapper component to use useNavigate()
const AppRoutes: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/post/:id" element={<PostPage />} />
      <Route path="/details" element={<DetailsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route
        path="/search"
        element={
          <SearchResultsPage
            onSearch={(query) =>
              navigate(`/search?s=${encodeURIComponent(query)}`)
            }
          />
        }
      />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      {/* Whole layout wrapper */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          overflowX: 'hidden', // ✅ prevent horizontal scroll on small screens
        }}
      >
        {/* Main content area */}
        <main style={{ flex: 1 }}>
          <ScrollToTop />
          <AppRoutes />
        </main>

        {/* Footer always stays at bottom */}
        <Footer />
      </div>
    </Router>
  );
};

export default App;
